import React, { useState, useEffect, useContext, useRef } from 'react';
import lunr from 'lunr';

import { Context } from '@store/store';
import useClickOutside from '@utils/useClickOutside';

import { SearchInputWrapper, StyledSearchInput } from './search-input.styles';

import SearchResultHeader from '../search-result-header';
import SearchResultsSidebar from '../search-results-sidebar';

const SearchInput = ({ searchIndexUrl, textByPagesUrl }) => {
  const [state, dispatch] = useContext(Context);
  const wrapperRef = useRef(null);
  const [query, setQuery] = useState('');
  const [searchIndexByQuery, setSearchIndexByQuery] = useState([]);
  const [searchIndexData, setSearchIndexData] = useState(null);
  const [textByPagesData, setTextByPagesData] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useClickOutside(wrapperRef, 'sidebar');

  useEffect(() => {
    const fetchSearchIndex = async () => {
      setIsLoading(true);
      await Promise.all([fetch(searchIndexUrl), fetch(textByPagesUrl)])
        .then(responses => Promise.all(responses.map(res => res.json())))
        .then(data => {
          setSearchIndexData(data[0]);
          setTextByPagesData(data[1]);
        })
        .catch(err => setError(err))
        .finally(() => setIsLoading(false));
    };

    fetchSearchIndex();
  }, [searchIndexUrl]);

  useEffect(() => {
    if (query) {
      setSearchIndexByQuery(lunr.Index.load(searchIndexData).search(query));
    } else {
      setSearchIndexByQuery([]);
    }
  }, [query]);

  return (
    <div
      style={{ display: state.isSearchSidebarOpened ? 'block' : 'none' }}
      data-is-opened={state.isSearchSidebarOpened}
      ref={wrapperRef}
    >
      <SearchInputWrapper>
        {error ? (
          <span>Ошибка сети</span>
        ) : isLoading ? (
          <span>Загрузка…</span>
        ) : (
          <form
            style={{ height: '100%', width: '100%' }}
            onSubmit={e => e.preventDefault()}
          >
            <StyledSearchInput
              type="search"
              placeholder="Искать в тексте…"
              onChange={e => {
                setQuery(e.target.value);
                dispatch({ type: 'SET_SEARCH_QUERY', payload: e.target.value });
              }}
            />
          </form>
        )}
      </SearchInputWrapper>
      {query && (
        <>
          <SearchResultHeader searchResultsCount={searchIndexByQuery.length} />
          <SearchResultsSidebar
            searchResults={searchIndexByQuery}
            textByPages={textByPagesData}
            query={query}
          />
        </>
      )}
    </div>
  );
};

export default SearchInput;
